export default class ArcgisToken {
    public id = '';
    public token = '';
    public expires = 0;

    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model._id) {
            this.id = model._id;
        }
        if (model.token) {
            this.token = model.token;
        }
        if (model.expires) {
            this.expires = model.expires;
        }
    }
}
